import {ArrowRight, Loader2} from "lucide-react";
import {Link} from "react-router-dom";
import type {ReactNode} from "react";
import "./rides.css";
import {useRideLanguage, type RideLanguage} from "../ride-language";

export function RideShell({children, action}: {children: ReactNode; action?: ReactNode}) {
  const {language, setLanguage} = useRideLanguage();
  return <div className="ride-app" lang={language} dir={language === "he" ? "rtl" : "ltr"}>
    <header className="ride-nav"><div className="ride-nav-inner">
      <span className="ride-brand"><img className="ride-brand-icon" src="/cherri-logo.png" width="40" height="40" alt=""/>cherri</span>
      <div className="ride-nav-actions">{action}<select className="ride-language" aria-label="Language / שפה" value={language} onChange={event => setLanguage(event.target.value as RideLanguage)}><option value="en">English</option><option value="he">עברית</option></select></div>
    </div></header>
    <main className="ride-content">{children}</main>
  </div>;
}

export function RideLoading() {
  const {t} = useRideLanguage();
  return <div className="ride-state" role="status"><Loader2 className="animate-spin"/><h2>{t("Loading…")}</h2></div>;
}

export function RideNotice({children, error = false}: {children: ReactNode; error?: boolean}) {
  return <div className={`ride-notice ${error ? "ride-notice-error" : ""}`} role={error ? "alert" : "status"}>{children}</div>;
}

export function SignInPrompt({href, text = "Sign in to see your group’s rides and request a seat."}: {href: string; text?: string}) {
  const {t} = useRideLanguage();
  return <section className="ride-state ride-panel"><img className="ride-logo-large" src="/cherri-logo.png" width="64" height="64" alt="Cherri"/><h2>{t("Sign in")}</h2><p>{t(text)}</p><Link className="ride-button" to={href}>{t("Continue to sign in")} <ArrowRight size={18}/></Link></section>;
}
